import React, { useEffect, useState, useCallback } from 'react';
import { useRouter } from 'next/router';
import Gamepads from '@components/Gamepad';
import NewPlayGame from '@components/NewPlayGame';
import Spinner from '@util/spinner';
import { getBotDetails } from "@services/api";
import OpenWorldTestDriveLoadingScreen from '@components/OpenWorldTestDriveLoadingScreen';
import { safeLocalStorage } from '@utils/localstorage';

const App = () => {
  const router = useRouter();
  const [loading, setLoading] = useState(true)
  const user = safeLocalStorage.getItem('token')

  const init = useCallback(async () => {
    const allBots = await getBotDetails()
    if (allBots?.length > 0) {
      const tournamentData = safeLocalStorage.getItem('tournamentData')
      const test_ready = await allBots?.find((i) => i?.device_ref_id === tournamentData?.deviceId)
      if (test_ready && test_ready?.device_ref_id === tournamentData?.deviceId) {
        setLoading(false)
      } else {
        setLoading(false)
        router.push(`/testdrive`);
      }
    } else {
      setLoading(false)
      router.push(`/testdrive`);
    }
  }, [user])

  useEffect(() => {
    if (!user || user?.user?.blocklisted) {
      router.push('/testdrive')
    } else {
      init();
    }
  }, [user, init])

  if (!user || user?.user?.blocklisted) {
    return <></>
  }

  return (
    <>
      {loading ?
        <Spinner loading={loading} />
        :
        <Gamepads>
          <OpenWorldTestDriveLoadingScreen />
          <NewPlayGame />
        </Gamepads>
      }
    </>
  )
}

export default App;
